<template>
  <div>
    <v-dialog v-model="show_error_dialog" :width="350">
      <v-card>
        <v-card-title>
          {{dialog_title}}
          <v-spacer></v-spacer>
          <v-btn icon @click="show_error_dialog=false">
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>{{dialog_error}}</v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" to="/user/profile#section-3">My Profile</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="($store.state.app.display ==='xs' || $store.state.app.display ==='sm')">
      <v-container
        class="white lighten-3 px-4 py-4 bottomnav"
        fluid
        style="position:fixed;bottom:0px;left:0px;right:0px;z-index:100"
      >
        <v-row justify="space-around" align="center">
          <div v-for="(button,i) in menu_buttons" :key="i">
            <v-badge overlap color="red" v-if="button.badge">
              <template v-slot:badge>{{button.badge}}</template>
              <v-btn
                icon
                :color="button.color"
                @click="button.click ? button.click() : null"
                :to="button.to ? button.to : null"
              >
                <v-icon>{{button.icon}}</v-icon>
              </v-btn>
            </v-badge>
            <v-btn
              v-else
              icon
              :color="button.color"
              @click="button.click ? button.click() : null"
              :to="button.to ? button.to : null"
              :disabled="button.disabled"
              :loading="button.loading"
            >
              <div
                :class="button.rank ? `rank-star rank-${$store.state.account.account.rank}-star` : ``"
              >
                <v-icon :large="button.large ? true : false">{{button.icon}}</v-icon>
              </div>
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </div>

    <v-card-actions class="secondary white--text" v-if="contest">
      <v-col cols="3">
        <v-icon dark>fa-gift</v-icon>
      </v-col>
      <v-col cols="6" class="text-center">
        <h3>Contest Entry</h3>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-btn
          icon
          dark
          @click="$eventBus.$emit('play_video',$store.state.app.tutorials.project_create['Contest'])"
        >
          <v-icon>fa-question</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>

    <v-card-actions class="cool_purple white--text" v-if="contest ">
      <v-col cols="12" class="pt-0 pb-2 text-center">
        <router-link class="nolink white--text" :to="`/contests/${contest.id}/${contest.slug}`">
          <h5>{{contest.title}}</h5>
        </router-link>
      </v-col>
    </v-card-actions>

    <v-container>
      <v-row class justify="center">
        <v-col cols="12" md="10" lg="8" xl="6">
          <v-row
            align="center"
            v-if="$store.state.app.display !=='xs' && $store.state.app.display !=='sm'"
          >
            <v-col cols="12">
              <v-text-field
                color="secondary"
                outlined
                v-model="project.title"
                hide-details
                label="What are you talking about today ?"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <v-text-field
                shaped
                color="secondary"
                outlined
                v-model="project.title"
                hide-details
                label="What are you talking about today ?"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-radio-group color="primary" v-model="upload_type" row>
              <v-radio color="primary" label="Raw clips" :value="1"></v-radio>
              <v-radio color="primary" label="Complete video" :value="2"></v-radio>
            </v-radio-group>
          </v-row>
          <v-row class justify="center" v-if="upload_type==2">
            <v-col cols="12">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_5.revisions"
                @delete="deleteVideo"
                :can_delete="true"
                :can_upload="true"
                :videos="section_5.videos"
                :uploads="section_5.uploads"
                title="Complete video"
                icon="fa-film"
                :single="true"
                :section="5"
              ></videos-upload>
            </v-col>
          </v-row>
          <v-row class justify="center" v-else>
            <v-col cols="12">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_1.revisions"
                @delete="deleteVideo"
                :can_delete="true"
                :can_upload="true"
                :videos="section_1.videos"
                :uploads="section_1.uploads"
                title="Intro &amp; Outro"
                icon="far fa-laugh"
                :section="1"
                :tutorial="$store.state.app.tutorials.project_create['Intro & Outro']"
              ></videos-upload>
            </v-col>
            <v-col cols="12">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_2.revisions"
                @delete="deleteVideo"
                :can_delete="true"
                :can_upload="true"
                :videos="section_2.videos"
                :uploads="section_2.uploads"
                title="The Story"
                icon="fa-history"
                :section="2"
                :tutorial="$store.state.app.tutorials.project_create['The Story']"
              ></videos-upload>
            </v-col>
            <v-col cols="12">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_3.revisions"
                @delete="deleteVideo"
                :can_delete="true"
                :can_upload="true"
                :videos="section_3.videos"
                :uploads="section_3.uploads"
                title="Key Features"
                icon="fa-key"
                :section="3"
                :tutorial="$store.state.app.tutorials.project_create['Key Features']"
              ></videos-upload>
            </v-col>
            <v-col cols="12">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_4.revisions"
                @delete="deleteVideo"
                :can_delete="true"
                :can_upload="true"
                :videos="section_4.videos"
                :uploads="section_4.uploads"
                title="Favourite Thing"
                icon="fa-child"
                :section="4"
                :tutorial="$store.state.app.tutorials.project_create['Favourite Thing']"
              ></videos-upload>
            </v-col>
          </v-row>

          <v-row v-if="error" id="error">
            <v-col cols="12">
              <v-alert type="error">{{error}}</v-alert>
            </v-col>
          </v-row>
          <v-row v-if="($store.state.app.display !=='xs' && $store.state.app.display !=='sm')">
            <v-col cols="12" class="text-center" v-if="canSave">
              <v-btn
                id="save-btn"
                large
                @click="saveProject"
                rounded
                color="green"
                :loading="uploading || loading"
                dark
              >
                Save
                <v-icon class="ml-2">fa-save</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import videos from "@/components/project_create/videos";
import Axios from "axios";

export default {
  name: "",
  data: () => ({
    upload_type: 1,
    contest: null,
    loading: false,
    modified: false,
    dialog_error: false,
    dialog_title: "",
    show_error_dialog: false,
    error: null,
    project: {
      title: "",
      uid: null,
      contest_id: null,
    },
    videos: [],
    uploads: [],
  }),
  components: {
    videosUpload: videos,
  },
  created() {
    this.getDraftId();
    // this.canUserCreateProject()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.contest_id) {
        vm.loadContest(to.query.contest_id);
      } else {
        vm.contest = null;
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.contest_id) {
      this.loadContest(to.query.contest_id);
    } else {
      this.contest = null;
    }
    next();
  },
  computed: {
    menu_buttons() {
      return [
        {
          color: "secondary",
          to: "/contests",
          icon: "fa-gift",
        },
        {
          color: "secondary",
          to: "/user/progress",
          icon: "fa-star",
          rank: true,
        },
        {
          color: "green",
          icon: "fa-save",
          click: this.saveProject,
          disabled: this.canSave ? false : true,
          large: true,
          loading: this.uploading || this.loading,
        },
        {
          color: "secondary",
          badge: this.$store.getters["notifications/count"],
          icon: "fa-bell",
          click: this.showNotifications,
        },
        {
          color: "secondary",
          icon: "fa-user",
          to: "/user/profile",
        },
      ];
    },
    uploading() {
      return this.uploads.length ? true : false;
    },
    canSave() {
      if (!this.videos.length) {
        return false;
      }
      return true;
    },
    section_1() {
      return {
        videos: this.videos.filter((v) => {
          return v.section === 1;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 1;
        }),
        revisions: [],
      };
    },
    section_2() {
      return {
        videos: this.videos.filter((v) => {
          return v.section === 2;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 2;
        }),
        revisions: [],
      };
    },
    section_3() {
      return {
        videos: this.videos.filter((v) => {
          return v.section === 3;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 3;
        }),
        revisions: [],
      };
    },
    section_4() {
      return {
        videos: this.videos.filter((v) => {
          return v.section === 4;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 4;
        }),
        revisions: [],
      };
    },
    section_5() {
      return {
        videos: this.videos.filter((v) => {
          return v.section === 5;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 5;
        }),
        revisions: [],
      };
    },
  },
  methods: {
    async getDraftId() {
      this.project.uid = await this.$api(`/account/user/projects/get-draft-id`);
    },
    showNotifications() {
      this.$eventBus.$emit("show_notifications");
    },
    async saveProject() {
      try {
        this.loading = true;
        this.project = await this.$api({
          method: "POST",
          url: `/account/user/projects`,
          data: this.project,
        });
        await this.$api({
          method: "POST",
          url: `/account/user/projects/${this.project.id}/add-videos`,
          data: {
            videos: this.videos,
          },
        });
        this.modified = false;
        this.$router.push(`/user/projects/${this.project.id}`);
      } catch (ex) {
        this.error = ex.error;
        this.scrollToError();
      }
      this.loading = false;
    },
    async loadContest(id) {
      try {
        this.contest = await this.$api({
          method: "GET",
          url: `/contests/${id}`,
        });
        this.project.contest_id = this.contest.id;

        if (this.contest.min_rank > this.$store.state.account.account.rank) {
          this.dialog_title = this.$store.state.app.project_requirements.rank_required.title; //'Rank restriction'
          this.dialog_error = this.$store.state.app.project_requirements.rank_required.description; //'You need a higher rank to enter this contest'
        }
      } catch (ex) {
        console.log("ex", ex);
        alert(ex);
      }
    },
    async canUserCreateProject() {
      let profile_videos = await this.$api({
        method: "GET",
        url: `/account/user/profile-videos`,
      });
      let valid_thank_you_video = profile_videos.find((v) => {
        return v.section === 3;
      });
      if (!valid_thank_you_video) {
        this.dialog_title = this.$store.state.app.project_requirements.video_required.title; //'Just one thing'
        this.dialog_error = this.$store.state.app.project_requirements.video_required.description; //'You must have a published thank you video to create a project'
        this.show_error_dialog = true;
        return;
      }
      if (valid_thank_you_video.approved !== 1) {
        this.dialog_title = this.$store.state.app.project_requirements.video_review.title; //'Almost there'
        this.dialog_error = this.$store.state.app.project_requirements.video_review.description; //'Waiting on publishing team… in the meantime ensure all your wallet and setting info is updated and current and other things like links/resume/other videos (work experience) are completed… blah blah'
        this.show_error_dialog = true;
      }
    },
    async uploadVideo(options) {
      this.modified = true;
      let upload = {
        section: options.section,
        file: options.file,
        progress: 0,
      };
      this.uploads.push(upload);

      try {
        let upload_url = await this.$api({
          method: "POST",
          url: `/account/upload-url`,
          data: {
            file: {
              name: options.file.name,
              size: options.file.size,
              type: options.file.type,
            },
            key: `project-videos/${this.project.uid}/${options.section}`,
          },
        });
        var upload_options = {
          headers: {
            "Content-Type": options.file.type,
            "x-amz-acl": "public-read",
          },
          Metadata: {
            "Content-Disposition": "attachment",
          },
          onUploadProgress: function (progressEvent) {
            upload.progress = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        };
        await Axios.put(upload_url, options.file, upload_options);

        this.addVideo({
          url: upload_url.split("?")[0],
          file_name: options.file.name,
          file_size: options.file.size,
          section: options.section,
        });
      } catch (ex) {
        alert("Error uploading video, please try again");
      }
      this.deleteUpload(upload);
    },
    async addVideo(video) {
      this.videos.push(video);
    },
    async deleteVideo(video) {
      if (!confirm("Delete video ?")) {
        return;
      }
      this.videos = this.videos.filter((v) => {
        return v !== video;
      });
    },
    deleteUpload(upload) {
      this.uploads = this.uploads.filter((v) => {
        return v !== upload;
      });
    },
    scrollToSave() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#save-btn", {
            duration: 300,
            offset: 70,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
    scrollToError() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#error", {
            duration: 300,
            offset: 70,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
  },
  mounted() {},
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        this.scrollToSave();
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
